import { Box, Link, Typography } from "@mui/material";
import { StatusIcon } from "src/components";
import { Links, TASK_ITEM_STATUSES } from "../../constants";
import { FeedItemDto } from "../../http";

interface IProps {
  feedItem: FeedItemDto;
}

const TaskItemStatusPropertyChange = (props: IProps) => {
  const status = TASK_ITEM_STATUSES.find((x) => x.id === props.feedItem.propertyChange!.value);

  return (
    <Typography variant="caption" sx={{ alignItems: "center" }}>
      <Link href={Links.User(props.feedItem.user.userId)}>{props.feedItem.user.displayName}</Link> updated status to
      <Box component="span" sx={{ fontWeight: "bold", ml: "2px" }}>
        <StatusIcon status={status!} sx={{ position: "relative", top: "2px" }} fontSize="small" />
        <span> {status!.name}</span>
      </Box>
    </Typography>
  );
};

export { TaskItemStatusPropertyChange };
